import Item from './Item';
import { EVENT_TYPE, IMAGE_BOX } from '@/common/constants';
import { useToolBar } from '@/hooks';
export default {
  components: {
    Item
  },
  props: {
    isDigital: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const { setToolNameSelected } = useToolBar();
    return {
      setToolNameSelected
    };
  },
  data() {
    const items = [IMAGE_BOX.RECTANGLE, IMAGE_BOX.CIRCLE];

    return { items };
  },
  methods: {
    onClick(actionValue) {
      if (
        actionValue === IMAGE_BOX.RECTANGLE.value ||
        actionValue === IMAGE_BOX.CIRCLE.value
      ) {
        if (this.isDigital)
          this.$root.$emit(EVENT_TYPE.DIGITAL_ADD_ELEMENT, actionValue);
        else this.$root.$emit('printAddElement', actionValue);
      }

      this.setToolNameSelected({
        name: ''
      });
    }
  }
};
